import { setDisplayAssignmentStartDateChangeDialog } from './actions';
import { singleValueReducer } from 'store/reducerUtils';

export const showAssignmentStartDateChangeDialog = (
    singleValueReducer(setDisplayAssignmentStartDateChangeDialog.action, false)
);
